import React, { useEffect, useRef, useState } from "react";
import AccountShell, { useAccountProfile } from "./AccountShell";
import { accountRequest, notifyAccountChange } from "./accountApi";

export default function Profile() {
  return (
    <AccountShell title="My Profile">
      <ProfileForm />
    </AccountShell>
  );
}
function ProfileForm() {
  const {
    user,
    setUser,
    loading,
    error: loadError,
    retry,
  } = useAccountProfile();
  const [form, setForm] = useState({
    name: "",
    city: "",
    state: "",
    country: "",
  });
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  const submitting = useRef(false);
  useEffect(() => {
    if (user)
      setForm({
        name: user.name,
        city: user.city,
        state: user.state,
        country: user.country,
      });
  }, [user]);
  async function save(event) {
    event.preventDefault();
    if (submitting.current) return;
    submitting.current = true;
    setBusy(true);
    setError("");
    setMessage("");
    try {
      const data = await accountRequest("update-profile", form);
      setUser(data.user);
      setMessage(data.message);
      notifyAccountChange();
    } catch (error) {
      setError(error.message);
    } finally {
      submitting.current = false;
      setBusy(false);
    }
  }
  if (loading) return <p role="status">Loading your profile…</p>;
  if (loadError)
    return (
      <>
        <p className="ltc-member-error" role="alert">
          {loadError}
        </p>
        <button className="ltc-member-submit" onClick={retry}>
          Try again
        </button>
      </>
    );
  if (!user) return null;
  return (
    <form onSubmit={save}>
      <p className="ltc-member-intro">Keep your personal details up to date.</p>
      {error && (
        <p className="ltc-member-error" role="alert">
          {error}
        </p>
      )}
      {message && (
        <p className="ltc-member-success" role="status">
          {message}
        </p>
      )}
      <fieldset className="ltc-member-fields" disabled={busy}>
        <div className="ltc-member-field">
          <label htmlFor="member-name">Full Name</label>
          <input
            id="member-name"
            autoComplete="name"
            value={form.name}
            maxLength={100}
            required
            onChange={(event) => setForm({ ...form, name: event.target.value })}
          />
        </div>
        <div className="ltc-member-field">
          <label htmlFor="member-mobile">Registered Mobile Number</label>
          <input
            id="member-mobile"
            value={`+${user.country_code} ${user.mobile}`}
            readOnly
          />
          <small>Your mobile number is your login ID.</small>
        </div>
        <div className="ltc-member-grid">
          {[
            ["city", "City", "address-level2"],
            ["state", "State", "address-level1"],
          ].map(([key, label, autoComplete]) => (
            <div className="ltc-member-field" key={key}>
              <label htmlFor={`member-${key}`}>{label}</label>
              <input
                id={`member-${key}`}
                value={form[key]}
                autoComplete={autoComplete}
                required
                maxLength={100}
                onChange={(event) =>
                  setForm({ ...form, [key]: event.target.value })
                }
              />
            </div>
          ))}
        </div>
        <div className="ltc-member-field">
          <label htmlFor="member-country">Country</label>
          <input
            id="member-country"
            autoComplete="country-name"
            value={form.country}
            required
            maxLength={100}
            onChange={(event) =>
              setForm({ ...form, country: event.target.value })
            }
          />
        </div>
        <button className="ltc-member-submit" type="submit">
          {busy ? "Saving…" : "Save Profile"}
        </button>
      </fieldset>
    </form>
  );
}
